import { render, staticRenderFns } from "./hyjyInfo.vue?vue&type=template&id=3f13f90b&scoped=true"
import script from "./hyjyInfo.vue?vue&type=script&lang=js"
export * from "./hyjyInfo.vue?vue&type=script&lang=js"
import style0 from "./hyjyInfo.vue?vue&type=style&index=0&id=3f13f90b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f13f90b",
  null
  
)

export default component.exports